/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Featured_Badge1Inputs */

const vi_cmspost_featured_badge1 = /** @type {(inputs: Cmspost_Featured_Badge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nổi bật`)
};

/**

* @param {Cmspost_Featured_Badge1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_featured_badge1 = /** @type {((inputs?: Cmspost_Featured_Badge1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Featured_Badge1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_featured_badge1(inputs)
});
export { cmspost_featured_badge1 as "cmsPost_featured_badge" }